export const typography_novasense = {
  defaultFontFamily: 'Inter',

  displayLarge: {
    fontFamily: 'Inter Bold',
    size: '4rem',
    lineHeight: '4.5rem',
    weight: 700
  },
  titleLarge: {
    fontFamily: 'Inter SemiBold',
    size: '1.75rem',
    lineHeight: '2.25rem',
    weight: 600
  },
  bodyLarge: {
    fontFamily: 'Inter',
    size: '1rem',
    lineHeight: '1.5rem',
    weight: 400
  },
  labelMedium: {
    fontFamily: 'Inter Medium',
    size: '0.75rem',
    weight: 500
  }
}
